module.exports = __webpack_public_path__ + "static/media/CatWalk-Gold-Shorts.b93fb3b4.jpg";